module.exports = __webpack_public_path__ + "img/contributionplanner-piggybank.4e97e3c6.svg";